import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import VueSlider from 'vue-slider-component';
import vSelect from 'vue-select';
import SvgIcon from '../components/SvgIcon.vue';
import SvgSprite from '../components/SvgSprite.vue';
import Separator from '../components/Separator.vue';
import Card from '../components/Card.vue';
import Collapse from '../components/Collapse.vue';
import SelectBox from '../components/SelectBox.vue';
import Box from '../components/Box.vue';
import CopyInput from '../components/CopyInput.vue';
import Stepper from '../components/stepper/Stepper.vue';
import StepperStep from '../components/stepper/StepperStep.vue';
import ChangiRecommendsButton from '../components/Button.vue';
import FormFieldInvalid from '../forms/FormFieldInvalid.vue';
import AuthModal from '../modules/auth/containers/AuthModal.vue';
import Header from '../modules/header/containers/Header.vue';
import HomeBanner from '../containers/HomeBanner.vue';
import CategoryBanner from '../containers/CategoryBanner.vue';
import Brands from '../containers/Brands.vue';
import ChangiRecommendsLogo from '../components/ChangiRecommendsLogo.vue';
import Spinner from '../components/Spinner.vue';
const SharedPlugin = {};
SharedPlugin.install = function (Vue) {
    // INIT LIBS
    Vue.use(BootstrapVue);
    Vue.use(BootstrapVueIcons);
    Vue.use(Vuelidate);
    Vue.component('v-select', vSelect);
    Vue.component('vue-slider', VueSlider);
    // SHARED COMPONENTS
    Vue.component('svg-icon', SvgIcon);
    Vue.component('svg-sprite', SvgSprite);
    Vue.component('separator', Separator);
    Vue.component('card', Card);
    Vue.component('collapse', Collapse);
    Vue.component('select-box', SelectBox);
    Vue.component('box', Box);
    Vue.component('copy-input', CopyInput);
    Vue.component('changirecommends-button', ChangiRecommendsButton);
    Vue.component('form-field-invalid', FormFieldInvalid);
    Vue.component('changirecommends-auth-modal', AuthModal);
    Vue.component('stepper', Stepper);
    Vue.component('stepper-step', StepperStep);
    // ChangiRecommends COMPONENTS
    Vue.component('ChangiRecommendsHeader', Header);
    Vue.component('ChangiRecommendsHomeBanner', HomeBanner);
    Vue.component('ChangiRecommendsCategoryBanner', CategoryBanner);
    Vue.component('ChangiRecommendsBrands', Brands);
    Vue.component('ChangiRecommendsLogo', ChangiRecommendsLogo);
    Vue.component('ChangiRecommendsSpinner', Spinner);
    Vue.mixin({
        methods: {
            getAssetImage(image) {
                // do not break app if image not found
                try {
                    return require(`images/${image}`);
                }
                catch (error) {
                    console.error(error);
                    return null;
                }
            },
        },
    });
};
export default SharedPlugin;
